import { render, staticRenderFns } from "./Root.view.vue?vue&type=template&id=c337d606&scoped=true&"
import script from "./Root.view.vue?vue&type=script&lang=ts&"
export * from "./Root.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c337d606",
  null
  
)

export default component.exports